"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTargetAngle = exports.createElementFromHTML = exports.cubeLikeConfig = exports.pad = exports.updateOcclude = void 0;
function updateOcclude(faceType) {
    var box = faceType.base.playground.cube.mesh;
    faceType.cNormal.copy(faceType.normal).applyMatrix3(box.normalMatrix);
    faceType.cPos.copy(faceType.pos).applyMatrix4(faceType.m4.multiplyMatrices(faceType.base.camera.instance.matrixWorldInverse, box.matrixWorld));
    var d = faceType.cPos.negate().dot(faceType.cNormal);
    faceType.element.style.visibility = d < 0 ? "hidden" : "visible";
}
exports.updateOcclude = updateOcclude;
function pad(n, l) {
    for (var r = n.toString(); r.length < l; r = 0 + r)
        ;
    return r;
}
exports.pad = pad;
exports.cubeLikeConfig = {
    initialScale: [0, 0, 0],
    initialRotation: [Math.PI / 3, -Math.PI / 3, Math.PI / 3],
    startAnimationInnerRotationConfig: {
        x: 0,
        y: Math.PI / 4,
        z: 0,
        duration: 2
    },
    startAnimationInnerScalingConfig: {
        x: 1,
        y: 1,
        z: 1,
        duration: 2
    },
    showChatAnimationInnerRotationConfig: {
        x: 0,
        y: -Math.PI / 4,
        z: 0,
        duration: 2
    },
    showMusicAnimationInnerRotationConfig: {
        x: 0,
        y: -Math.PI / 4,
        z: 0,
        duration: 2
    },
    showChatAnimationOuterRotationConfig: {
        x: 0,
        y: 0,
        z: 0,
        duration: 2
    },
    updateParameter: 5
};
function createElementFromHTML(htmlString) {
    var div = document.createElement('div');
    div.innerHTML = htmlString.trim();
    // Change this to div.childNodes to support multiple top-level nodes.
    return div.firstChild;
}
exports.createElementFromHTML = createElementFromHTML;
function getTargetAngle(angle) {
    var remain = angle % (2 * Math.PI);
    var minor = angle - remain - 0.25 * Math.PI;
    var major = angle + ((7 * Math.PI / 4) - remain);
    var newAngle = remain < Math.PI ? minor : major;
    return newAngle;
}
exports.getTargetAngle = getTargetAngle;
